export const openDB = (): Promise<IDBDatabase> => {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open('ImageCacheDB', 1);

		request.onerror = (event) => {
			reject(`IndexedDB error: ${(event.target as IDBRequest).error}`);
		};

		request.onupgradeneeded = (event) => {
			const db = (event.target as IDBOpenDBRequest).result;
			if (!db.objectStoreNames.contains('images')) {
				db.createObjectStore('images', { keyPath: 'id' });
			}
		};

		request.onsuccess = (event) => {
			resolve((event.target as IDBOpenDBRequest).result);
		};
	});
};

interface CachedImage {
	id: string;
	base64Data: string;
}

export const cacheImage = async (
	db: IDBDatabase,
	id: string,
	base64Data: string
): Promise<void> => {
	return new Promise((resolve, reject) => {
		const transaction = db.transaction('images', 'readwrite');
		const store = transaction.objectStore('images');

		const request = store.put({ id, base64Data } as CachedImage);

		request.onsuccess = () => {
			resolve(undefined);
		};

		request.onerror = (event) => {
			reject(`Failed to cache image: ${(event.target as IDBRequest).error}`);
		};
	});
};

interface GetImageResult {
	base64Data: string;
}

export const getImageFromCache = async (
	db: IDBDatabase,
	id: string
): Promise<string | null> => {
	return new Promise((resolve, reject) => {
		const transaction = db.transaction('images', 'readonly');
		const store = transaction.objectStore('images');

		const request = store.get(id);

		request.onsuccess = (event: Event) => {
			const result = (event.target as IDBRequest<GetImageResult | undefined>)
				.result;
			resolve(result ? result.base64Data : null);
		};

		request.onerror = (event: Event) => {
			reject(
				`Failed to retrieve image from cache: ${(event.target as IDBRequest).error}`
			);
		};
	});
};
